import { SetHeaderService } from "@/helper/userHelper";
import service from "../baseHttpService";
/* eslint @typescript-eslint/no-var-requires: "off" */
const qs = require("qs");
class AssetService {
  DoGetAssetTemplateCodeByAssetTemplateIdList(assetTemplateIdList: Array<number>) {
    const _input = {
      assetTemplateIdList: assetTemplateIdList,
    };
    return service.peakExportAPI
      .post("/api/Asset/GetAssetTemplateCodeByAssetTemplateIdList", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
}
export default new AssetService();
